import { useCheckOperationType } from '@/functions/check_operation_type';
import I18n from 'i18n-js';

/**
 * Helper to reduce repition when adding items
 * @param {string} name - key for translation
 * @param {boolean} active - check for current route params
 * @param {array} links - array of link items
 */
function addNavItem(name, active, links) {
  return {
    name: I18n.t(name),
    active: active,
    links: links,
  };
}

/**
 * Helper to reduce repition when adding links
 * @param {string} name - route name
 * @param {string} type - type of operation eg. sets, stations, heavy_mobile_equipment
 * @param {string} label - link text
 */
function addLink(name, type, label) {
  return {
    name: name,
    type: type,
    label: I18n.t(label),
  };
}

export function useShaftOperationTypeNavItems() {
  const { isSet, isStation, isHME, isOverview } = useCheckOperationType();

  const SET_ITEMS = addNavItem('shafts.sets', (isSet.value || isOverview.value), [
    addLink('shaftV2IssuesOverview', 'overview', 'shafts.set_overview'),
    addLink('shaftV2IssuesTypeSets', 'sets', 'shafts.3d_model'),
  ]);

  const STATIONS_ITEMS = addNavItem('shafts.stations', isStation.value, [
    addLink('shaftV2IssuesTypeStations', 'stations', 'shafts.diagrams'),
  ]);

  const HME_ITEMS = addNavItem('shafts.heavy_mobile_equipment', isHME.value, [
    addLink('shaftV2IssuesTypeHmes', 'heavy_mobile_equipment', 'shafts.diagrams'),
  ]);

  function getNavigationItems(hasHME) {
    let items = [SET_ITEMS, STATIONS_ITEMS];
    hasHME && items.push(HME_ITEMS);

    return items;
  }

  return { getNavigationItems };
}

export function usePlantOperationTypeNavItems() {
  const { isPlant, isHME } = useCheckOperationType();

  const PLANT_ITEMS = addNavItem('plants.plant', isPlant.value, [
    addLink('regions', 'plant', 'plants.regions'),
  ]);

  const HME_ITEMS = addNavItem('plants.heavy_mobile_equipment', isHME.value, [
    addLink('regionsTypeHmes', 'heavy_mobile_equipment', 'plants.diagrams'),
  ]);

  function getNavigationItems(hasHME) {
    let items = [PLANT_ITEMS];
    hasHME && items.push(HME_ITEMS);

    return items;
  }

  return { getNavigationItems };
}
